/**
* @description: 团购管理
* @author: wgt
*/

<template>
    <div class="group-manage">
        <ul class="row list-tit" v-show="titShow">
            <li class="col-md-4" v-for="menuItem in menu" :key="menuItem.id"><span class="col-md-10"
                    @click="titClk(menuItem.id)">{{ menuItem.name }}</span></li>
        </ul>
        <div class="list-con">
            <div v-show="listShow1">
                <div class="group-list">
                    <h1>团购核销兑换绑定授权设置</h1>
                    <el-form :inline="true">
                        <el-form-item label="门店">
                            <el-input v-model="shop_name" placeholder="请输入门店名称"></el-input>
                        </el-form-item>
                        <el-button type="primary" @click="groupTable(1)">查询</el-button>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="group_table"
                        :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column prop="group_consume" label="美团">
                            <template slot-scope="scope">
                                <el-select size="mini" v-model="scope.row.group_consume"
                                    @change="tsxSub(scope.row, 'mt')" placeholder="请选择"
                                    style="width: 80px;margin-right: 10px;">
                                    <el-option label="开启" value="1"></el-option>
                                    <el-option label="关闭" value="-1"></el-option>
                                </el-select>
                                <el-button type="text" @click="getMeituanAuth(scope.row)">美团授权</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dy_group_consume" label="抖音">
                            <template slot-scope="scope">
                                <el-select size="mini" v-model="scope.row.dy_group_consume"
                                    @change="tsxSub(scope.row, 'dy')" placeholder="请选择"
                                    style="width: 80px;margin-right: 10px;">
                                    <el-option label="开启" value="1"></el-option>
                                    <el-option label="关闭" value="-1"></el-option>
                                </el-select>
                                <el-button type="text" @click="openDyAuth(scope.row)">抖音绑定</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="group_page" :total="group_total" @current-change="groupTable">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                </div>
            </div>
            <div v-show="listShow2">
                <div class="mt-list">
                    <h1>{{ platform == 'mt' ? '美团团购兑换卡券绑定设置' : '抖音团购兑换卡券绑定设置' }}</h1>
                    <el-form :inline="true">
                        <el-form-item label="门店">
                            <el-select v-model="mt_formdata.shop_id" filterable placeholder="请选择门店">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="mt_formdata.status" filterable placeholder="请选择状态">
                                <el-option label="全部" value="0"></el-option>
                                <el-option label="下架" value="-1"></el-option>
                                <el-option label="售卖中" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="绑定状态">
                            <el-select v-model="mt_formdata.binding" filterable placeholder="请选择绑定状态">
                                <el-option label="全部" value="0"></el-option>
                                <el-option label="已绑定" value="1"></el-option>
                                <el-option label="未绑定" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="团购名称">
                            <el-input v-model="mt_formdata.title" placeholder="请输入团购名称"></el-input>
                        </el-form-item>
                        <el-button type="primary" @click="mtTable(1)">查询</el-button>
                        <el-button type="primary" @click="syncGroupData(1)">同步团购数据</el-button>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="mt_table"
                        :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
                        <el-table-column prop="deal_group_id" label="团购ID"></el-table-column>
                        <el-table-column prop="shop_name" label="团购门店名称"></el-table-column>
                        <el-table-column prop="title" label="团购套餐名称"></el-table-column>
                        <el-table-column label="团购价/原价">
                            <template slot-scope="scope">
                                <span>{{ scope.row.actual_amount }}元/{{ scope.row.origin_amount }}元</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 1" style="color: #0ace0a;">{{ scope.row.status_str
                                    }}</span>
                                <span v-else-if="scope.row.status == -1">{{ scope.row.status_str }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sale_start_time" label="团购开始时间"></el-table-column>
                        <el-table-column prop="sale_end_time" label="团购结束时间"></el-table-column>
                        <el-table-column label="绑定卡券">
                            <template slot-scope="scope">
                                <span v-if="scope.row.gift_id == '0'" style="color: #f00;">{{ scope.row.coupon_name
                                    }}</span>
                                <span v-else>{{ scope.row.coupon_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="scope.row.gift_id == '0'"
                                    @click="openVoucherPop(scope.row)">绑定卡券</el-button>
                                <el-button type="text" v-if="scope.row.gift_id != '0'"
                                    @click="openVoucherPop(scope.row)">重新绑定</el-button>
                                <el-button type="text" style="color: #f00;" v-if="scope.row.gift_id != '0'"
                                    @click="confirmUnbind(scope.row)">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="mt_formdata.page" :total="mt_total" @current-change="mtTable">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                </div>
            </div>
            <div v-show="listShow3">
                <div class="dy-list">
                    <h1>抖音团购兑换卡券绑定设置</h1>
                    <el-button @click="backFun">返回</el-button>
                </div>
            </div>
        </div>
        <!-- 抖音绑定弹窗 -->
        <el-dialog title="抖音绑定" :visible.sync="dyDialogVisible" width="30%" :before-close="cancelDyAuth">
            <el-form>
                <el-form-item label="抖音商家ID">
                    <el-input v-model="dy_merchant_id" placeholder="请输入抖音商家id"></el-input>
                </el-form-item>
                <el-form-item label="抖音门店ID">
                    <el-input v-model="douyin_shop_id" placeholder="请输入抖音门店id"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelDyAuth">取 消</el-button>
                <el-button type="primary" @click="confirmDyAuth">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 关联券弹窗 -->
        <div class="coupon-pop ele-hide" ref="coupon_pop">
            <el-form :inline="true">
                <el-select v-model="voucher_type" placeholder="请选择" @change="onVoucherTypeChange"
                    popper-class="high-index">
                    <el-option label="卡券" value="1"></el-option>
                </el-select>
                <el-select v-model="card_type_name" filterable placeholder="卡券类型" v-if="voucher_type == '1'"
                    @change="onPopQueryClick" popper-class="high-index">
                    <el-option label="开房套餐券" value="4"></el-option>
                </el-select>
                <el-select v-model="card_type_name" filterable placeholder="商品券类型" v-if="voucher_type == '2'"
                    @change="onPopQueryClick" popper-class="high-index">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="兑换券" value="1"></el-option>
                </el-select>
                <el-input v-model="query_voucher_name" clearable
                    :placeholder="voucher_type == '1' ? '请输入卡券名称' : '请输入商品券名称'"></el-input>
                <el-button type="primary" @click="onPopQueryClick">查询</el-button>
            </el-form>
            <el-table v-loading="pop_loading" element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" ref="coupon_table" :data="coupon_list"
                @select="onPopCouponSelect">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                <el-table-column prop="goods_name" label="名称"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="coupon_page_size"
                :current-page.sync="coupon_page" :total="coupon_total" @current-change="getPopCouponList">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    data() {
        return {
            titShow: true,
            listShow1: false,
            listShow2: false,
            listShow3: false,
            listShow4: false,
            loading: false,
            platform: '', // 平台：mt dy

            // 门店
            shop_list: [],
            shop_id: '',
            shop_name: '',
            // 团购核销兑换绑定授权设置
            group_page: 1,
            group_total: 0,
            group_table: [],
            // 抖音绑定弹窗
            dyDialogVisible: false,
            douyin_shop_id: '', // 抖音门店ID
            dy_merchant_id: '', // 抖音商家ID
            dy_shop_id: '', // 抖音门店ID

            // 美团团购兑换卡券绑定设置
            mt_formdata: {
                shop_id: '',
                page: 1,
                title: '',
                status: '',
                binding: '',
            },
            mt_table: [],
            mt_total: 0,
            voucher_type: '1', // 1：巨嗨卡券，2：友宝售后机商品券
            voucher_id: '', // 关联的券id
            voucher_name: '', // 关联的券名
            card_type: [
                // {
                //     id: '',
                //     text: '全部'
                // },
                // {
                //     id: '1',
                //     text: '优惠券'
                // },
                // {
                //     id: '2',
                //     text: '物品券'
                // },
                // {
                //     id: '3',
                //     text: '商品套餐券'
                // },
                {
                    id: '4',
                    text: '开房套餐券'
                }
            ],
            card_type_name: '4', // 卡券名称
            query_voucher_name: '', // 关联券弹窗检索名称
            coupon_page: 1,
            coupon_page_size: 5,
            coupon_total: 0,
            coupon_list: [],
            pop_loading: false,
            choosedVoucher: {}, // 选择的关联券
        }
    },
    computed: {
        menu() {
            let menu = {};
            if (!$.isEmptyObject(this.$store.state.menunew)) {
                menu = JSON.parse(this.$store.state.menunew);
                $.each(menu, function (k, v) {
                    if (v.id == '546') {
                        menu = v.submenu;
                        $.each(menu, function (m, n) {
                            if (n.id == '1355') {
                                menu = n.submenu;
                            }
                        });
                    }
                });
            }
            return menu;
        },
    },
    created() {
        this.getShop()
    },
    methods: {
        titClk(num) {
            const _this = this
            _this.titShow = false
            _this.listShow1 = false
            _this.listShow2 = false
            _this.listShow3 = false

            if (num == '1356') {
                _this.groupTable(1)
                _this.listShow1 = true
            } else if (num == '1357') {
                _this.mt_formdata.shop_id = _this.shop_list[0].id
                _this.platform = 'mt'
                _this.mtTable(1)
                _this.listShow2 = true
            } else if (num == '1358') {
                _this.mt_formdata.shop_id = _this.shop_list[0].id
                _this.platform = 'dy'
                _this.mtTable(1)
                _this.listShow2 = true
            }
        },
        backFun: function () {
            this.titShow = true
            this.listShow1 = false
            this.listShow2 = false
            this.listShow3 = false
        },
        getShop() {
            const _this = this

            Vue.axios.post('PublicData/api_getShopListByPurview', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
        },
        /*
         * 团购核销兑换绑定授权设置
         */
        // 列表
        groupTable: function (page) {
            const _this = this;

            _this.loading = true;
            _this.group_page = page
            Vue.axios.post('GroupBuying/getSetting', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_name": _this.shop_name
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        console.log(res);
                        if (page == 1) {
                            _this.group_total = Number(res.data.response.result.total);
                        }
                        _this.group_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                        _this.loading = false
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                    _this.loading = false
                });
        },
        // 开启或关闭美团/抖音核销兑换绑定授权
        tsxSub(row, type) {
            const _this = this
            console.log(row);

            _this.loading = true
            if (type == 'mt') {
                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": row.id,
                            "group_consume": row.group_consume,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg("操作成功");
                            _this.loading = false
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
            } else if (type == 'dy') {
                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": row.id,
                            "dy_group_consume": row.dy_group_consume,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg("操作成功");
                            _this.loading = false
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
            }

        },
        // 获取美团授权
        getMeituanAuth(row) {
            const _this = this
            console.log(row);

            _this.loading = true
            Vue.axios.post('Shop/getMeituanAuthUrl', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": row.shop_id,
                        "scope": "tuangou"
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        console.log(res.data.response.result)
                        // 浏览器打开新页面
                        window.open(res.data.response.result.auth_url, '_blank');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.loading = false
                })
                .catch(err => {
                    layer.msg("出错啦");
                    _this.loading = false
                });
        },
        // 打开抖音授权
        openDyAuth(row) {

            console.log('row', row);

            const _this = this
            _this.dy_shop_id = row.id
            _this.dyDialogVisible = true
            _this.douyin_shop_id = row.douyin_shop_id
            _this.dy_merchant_id = row.dy_merchant_id
        },
        // 取消抖音绑定
        cancelDyAuth() {
            const _this = this
            _this.dy_shop_id = ''
            _this.dyDialogVisible = false
            _this.douyin_shop_id = ''
            _this.dy_merchant_id = ''
        },
        // 确认抖音绑定
        confirmDyAuth() {
            const _this = this
            console.log('抖音门店ID:', _this.douyin_shop_id)
            console.log('抖音商家ID:', _this.dy_merchant_id)
            console.log('抖音门店ID:', _this.dy_shop_id)

            Vue.axios.post('shop/updateDyConfig', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.dy_shop_id,
                        "douyin_shop_id": _this.douyin_shop_id,
                        "dy_merchant_id": _this.dy_merchant_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("绑定成功");
                        _this.dyDialogVisible = false
                    } else {
                        _this.dyDialogVisible = false
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
                // 刷新
                _this.groupTable(_this.group_page)

        },
        // 美团团购兑换卡券绑定设置
        mtTable(page) {
            const _this = this
            let type = 0
            if (_this.platform == 'mt') {
                type = 2   // 美团
            } else if (_this.platform == 'dy') {
                type = 3   // 抖音
            }
            _this.mt_formdata.page = page
            _this.loading = true
            Vue.axios.post('GroupBuying/getList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_id": _this.mt_formdata.shop_id,
                        "status": _this.mt_formdata.status,
                        "binding": _this.mt_formdata.binding,
                        "title": _this.mt_formdata.title,
                        "type": type
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        console.log('美团团购兑换卡券绑定设置', res);
                        if (page == 1) {
                            _this.mt_total = Number(res.data.response.result.count);
                        }
                        _this.mt_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                        _this.loading = false
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                    _this.loading = false
                });
        },
        // 打开"关联券弹窗"
        openVoucherPop(row) {
            console.log('openVoucherPop', row);

            let _this = this

            this.voucher_type = (this.modify == 2 && this.good_detail.voucher_type != '') ? this.good_detail.voucher_type : '1'// 1：巨嗨卡券，2：友宝售后机商品券
            this.card_type_name = '4' // 卡券名称
            this.query_voucher_name = '' // 关联券弹窗检索名称
            let c_voucher_type = (this.modify == 2 && this.good_detail.voucher_type != '') ? this.good_detail.voucher_type : '1'

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['保存', '取消'],
                title: ['请选择商品关联券', true],
                area: ['780px', '580px'],
                content: $(_this.$refs.coupon_pop),
                offset: '100px',
                cancel: function () {
                    // 右上角关闭
                    _this.voucher_type = c_voucher_type
                    _this.voucher_id = ''
                    _this.voucher_name = ''
                    _this.choosedVoucher = {}
                }
            }, function () {
                if (!_this.choosedVoucher.goods_name) {
                    layer.msg("请先选择关联券")
                    return
                }
                _this.voucher_id = _this.choosedVoucher.goods_id
                _this.voucher_name = _this.choosedVoucher.goods_name + '（' + _this.choosedVoucher.goods_type_name + '）'
                _this.changeBinding(row.id, _this.voucher_id)
                layer.closeAll()
            }, function () {
                _this.voucher_type = c_voucher_type
                _this.voucher_id = ''
                _this.voucher_name = ''
                _this.choosedVoucher = {}
            });

            _this.$nextTick(() => {
                _this.getPopCouponList(1)
            })
        },
        // 修改绑定状态
        changeBinding(id, gift_id) {
            const _this = this
            console.log('changeBinding', _this.choosedVoucher);

            _this.loading = true
            Vue.axios.post('GroupBuying/binding', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id,
                        "gift_id": gift_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("操作成功");
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    _this.loading = false
                    _this.voucher_id = ''
                    _this.voucher_name = ''
                    _this.choosedVoucher = {}
                    _this.mtTable(1)
                });
        },

        // 确认解绑
        confirmUnbind(row) {
            const _this = this
            layer.confirm('确定要解绑该团购的卡券吗？', {
                btn: ['确定', '取消']
            }, function () {
                _this.changeBinding(row.id, '0')
            });
        },

        // 获取卡券列表
        getCouponList: function (page) {
            let _this = this
            let type = 0
            if (_this.platform == 'mt') {
                type = 2
            } else if (_this.platform == 'dy') {
                type = 3
            }
            _this.pop_loading = true
            _this.coupon_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": _this.mt_formdata.shop_id,
                        "type": $.trim(_this.card_type_name),
                        "name": _this.query_voucher_name,
                        "use_type": type
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "MerchantGift/getList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.coupon_total = Number(data.response.result.count);
                        }
                        _this.coupon_list = data.response.result.data;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // // 获取售后机商品券列表
        // getUboxVoucherList: function (page) {
        //     let _this = this
        //     _this.pop_loading = true
        //     _this.coupon_page = page
        //     let datas = {
        //         "header": Vue.request_header,
        //         "request": {
        //             "version": Vue.version,
        //             "param": {
        //                 "page": page,
        //                 "page_size": _this.coupon_page_size,
        //                 "shop_id": _this.mt_formdata.shop_id,
        //                 "type": $.trim(_this.card_type_name),
        //                 "name": _this.query_voucher_name
        //             }
        //         },
        //         "comment": ""
        //     };
        //     let datas2 = JSON.stringify(datas);
        //     $.ajax({
        //         type: "post",
        //         dataType: "json",
        //         url: Vue.ctUrl + "MerchantGift/getUboxVoucherList",
        //         crossDomain: true,
        //         xhrFields: {
        //             withCredentials: true
        //         },
        //         data: {
        //             json: datas2
        //         },
        //         success: function (data) {
        //             if (data.response.result_code == "true") {
        //                 if (page == 1) {
        //                     _this.coupon_total = Number(data.response.result.count);
        //                 }
        //                 _this.coupon_list = data.response.result.data;
        //                 _this.pop_loading = false;
        //             } else {
        //                 Vue.timeoutfun(data.response.result_status, _this);
        //                 layer.msg(data.response.error_msg);
        //             }
        //         },
        //         error: function (err) {
        //             layer.msg("出错啦");
        //         }
        //     });
        // },

        // 关联券弹窗券类型变化
        onVoucherTypeChange(val) {
            this.card_type_name = ''
            if (val == '1') {
                this.getCouponList(1)
            } else {
                // this.getUboxVoucherList(1)
            }
        },

        // 获取弹窗列表
        getPopCouponList(page) {
            if (this.voucher_type == '1') {
                this.getCouponList(page)
            } else {
                // this.getUboxVoucherList(page)
            }
        },

        // 点击兑换弹窗"查询"
        onPopQueryClick() {
            this.choosedVoucher = {}
            this.getPopCouponList(1)
        },

        // 选择券
        onPopCouponSelect(val, row) {
            this.$refs.coupon_table.clearSelection()
            this.$refs.coupon_table.toggleRowSelection(row, true)
            this.choosedVoucher = row
            console.log(this.choosedVoucher);

        },
        // 同步团购数据
        syncGroupData(page) {
            const _this = this
            _this.loading = true
            let type = 0
            if (_this.platform == 'mt') {
                type = 3   // 美团
            } else if (_this.platform == 'dy') {
                type = 1   // 抖音
            }
            Vue.axios.post('GroupBuying/syncList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "shop_id": Number(_this.mt_formdata.shop_id),
                        "platform": type
                    }
                }
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (res.data.response.result.has_more) {
                            _this.syncGroupData(res.data.response.result.next_page)
                        } else {
                            _this.loading = false
                            layer.msg("同步成功")
                            _this.mtTable(1)
                        }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    _this.loading = false
                });
        }
    }
}
</script>

<style lang="less" scoped>

.group-manage h1 {
    text-align: center;
    margin: 20px 0;
}

// 关联券弹窗
.coupon-pop {
    .el-form {

        .el-input,
        .el-select {
            width: 200px;
            margin-right: 10px;
        }
    }

    .el-table__header-wrapper>table>thead .el-checkbox {
        display: none !important;
    }

    .el-table {
        margin-top: 30px;
    }
}
</style>